// UI-free buyer/seller classification taxonomy shared by the Manage Investors
// filter drawer and the analytics Filter-Component. Kept free of React/MUI so
// the label/description maps can be imported (e.g. by Filter-Component/utils)
// without pulling the heavy FilterDrawer module into unrelated bundles.
//
// Definitions must stay in lockstep with the Analytics dashboard Buyer/Seller
// breakdown; the backend shares the classifier, so these are only the display
// strings.

// Buyer classifications (multi-select, OR-combined: a holder carries at most
// one buyer tag per window, so AND within the side is meaningless).
export type BuyerType = 'new' | 'returning' | 'existing'

// Seller classifications (multi-select, OR-combined, same reasoning).
export type SellerType = 'exited' | 'partial'

// How the buyer and seller selections combine when BOTH sides have at least
// one tick: 'and' (default, e.g. New buyer who also Exited) or 'or' (either
// side matches). Mirrors the Relationship entry-source toggle.
export type BuyerSellerMode = 'or' | 'and'

export const BUYER_TYPE_LABELS: Record<BuyerType, string> = {
  new: 'New',
  returning: 'Returning',
  existing: 'Existing'
}

export const BUYER_TYPE_DESCRIPTIONS: Record<BuyerType, string> = {
  new: 'Entered the register for the first time during the period and bought shares.',
  returning:
    'Had appeared on the register before, held 0 shares at the start of the period, and bought shares during it.',
  existing:
    'Held more than 0 shares at the start of the period and bought additional shares during it.'
}

export const SELLER_TYPE_LABELS: Record<SellerType, string> = {
  exited: 'Exited',
  partial: 'Partial'
}

export const SELLER_TYPE_DESCRIPTIONS: Record<SellerType, string> = {
  exited: 'Sold shares during the period and held 0 shares at the end of it.',
  partial: 'Sold shares during the period and still held shares at the end of it.'
}
